export default __webpack_public_path__ + "static/media/visionIcon.d664acd9.svg";